import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PianoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"piano"}/>
}
